/**
 * Created by YuPing.
 */
import axios from "axios";
import store from "../vuex/store";
import { bus } from "../bus.js";

axios.defaults.withCredentials = false;
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.common['Access-Control-Allow-Method'] = 'POST,GET';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头

//添加一个请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (window.localStorage.getItem("access-user")) {
      //config.headers.Authorization = window.localStorage.getItem('access-user');
    }
    store.state.loading = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 添加一个响应拦截器
axios.interceptors.response.use(
  function (response) {
    store.state.loading = false;
    if (response.data && response.data.code && response.data.code != 200) {
      if (response.data.code === 401) {
        bus.$emit("goto", "/login");
      }
      return Promise.reject(response.data.msg);
    }
    return response;
  },
  function (error) {
    store.state.loading = false;
    // Do something with response error
    console.log(error);
    return Promise.reject(error);
  }
);

//基地址
let base = process.env.API_ROOT;

//通用方法
export const POST = (url, params) => {
  return axios.post(`${url}`, params).then((res) => res.data);
  //  return axios.post(`${base}${url}`, params).then(res => res.data);
};

// RequestBody
export const postJsonRequest = (url, params) => {
  return axios({
    method: "post",
    url: url,
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  }).then((res) => res.data);
};

export const GET = (url, params) => {
  return axios
    .get(`${url}`, {
      params: params
    })
    .then((res) => res.data);
  //  return axios.get(`${base}${url}`, {
  //	  params: params
  //  }).then(res => res.data);
};

export const PUT = (url, params) => {
  return axios.put(`${url}`, params).then((res) => res.data);
  //return axios.put(`${base}${url}`, params).then(res => res.data)
};

export const DELETE = (url, params) => {
  return axios
    .delete(`${url}`, {
      params: params
    })
    .then((res) => res.data);
  // return axios.delete(`${base}${url}`, {
  //   params: params
  // }).then(res => res.data)
};

export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then((res) => res.data);
};

export const DOWNLOAD = (url, params) => {
  return axios
    .post(`${url}`, params, {
      headers: {
        "Content-Type": "application/json; application/octet-stream"
      },
      responseType: "arraybuffer"
    })
    .then((res) => res.data);
};



// WEBPACK FOOTER //
// ./src/api/index.js